import Boolean from "@base/Inputs/Boolean/Boolean"

export default Boolean;
